import { Grid } from "@material-ui/core";
import { PublicEnquiryModel } from "../../domain/PublicEnquiry";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { transferSourceService } from "../../services";
import { Select } from "@ofqual/portal-components/components/Select";

export const TransferDetails: React.FC<{
  sectionProps: SectionProps<PublicEnquiryModel>;
}> = ({ sectionProps }) => {
  const { control, disabled, item } = sectionProps;

  const [transferSourceLookups] = useLookup(transferSourceService);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="transferFrom"
          as={
            <Select
              label="Transfer from"
              data-test="transfer-from-select"
              readOnly={disabled || item?.canModifyTransferFrom === false}
              aria-label="Transfer from"
            >
              {transferSourceLookups}
            </Select>
          } />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Controller
          control={control}
          name="transferOwnership"
          as={
            <Select
              label="Transfer ownership"
              data-test="transfer-ownership-select"
              readOnly={disabled || item?.canModifyTransferOwnership === false}
              aria-label="Transfer ownership"
            >
              {transferSourceLookups}
            </Select>
          } />
      </Grid>
    </Grid>
  );
}